module.exports = __webpack_public_path__ + "img/Background.4573f95c.jpg";